<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">                    
                    <div class="content table-responsive table-full-width table-upgrade" *ngIf="plans.length>0">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th ></th>
                                    <th *ngFor="let p of plans">{{p.name}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="font-weight-bold">Credits</td>
                                    <td *ngFor="let p of plans">{{p.credits==-1? "Unlimited":p.credits}}</td>
                                </tr>
                                <tr>
                                    <td class="font-weight-bold">Validity</td>
                                    <td *ngFor="let p of plans">{{p.validity}} {{p.validityType}}</td>
                                </tr>
                                
                                <tr>
                                    <td class="font-weight-bold">Price</td>
                                    <td *ngFor="let p of plans">
                                        {{p.credits==-1 && !envData.data.landingpage.showexclusiveplanprice ? 'Contact us' : p.currency + (p.price | number) }}
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td *ngFor="let p of plans">
                                        <button [disabled]="disableBtn" *ngIf="canBuy(p)"
                                         [style]="style.btnstyle" class="btn btn-round btn-fill" (click)="buyPlan(p)">Buy Credits</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                    <div class="d-flex justify-content-center align-content-center p-2">
                        <i class="fa fa-spinner spin-icon spinner" style="font-size: large ;" *ngIf="plans.length<=0"></i>

                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="paymentRedirectUrl">
            Click <a class="text-info text-bold" (click)="openPaymentWindow(paymentRedirectUrl)">here</a> if payment page does not open: If link does not open automatically, ensure that pop-up blocker is disabled in broswer settings.
        </div>
    </div>
</div>
